// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  SIPContent:
    'Active, Terminated, Expired, Registered SIP,SWP/STP reports are updated once in a month and have no correlation with Portfolio Valuation (Holdings) Report. ' +
    '<br/>' +
    'Bounced SIP data is updated on Transaction + 2 business days.',

  production: false,
  CommonBaseHref: '',
  AMCLogoPath: window.location.origin + '/assets/images/NPS/',

  IsWrapperAPI: true,
  CompayName: 'IFA',
  CompanyId: 1, // 4053 
  //godigital : 001, optimoney: 100,Optiwealth : 111
  IsOptimoney: false,
  IsOptimoneyWealth: false,
  IsSubscribed: true, // used for enabling somefeature for client like signup option,sending mail etc
  DbName: 'Chitaah',
  environmentDigio: 'sandbox'
};
